<div class="p-6">
  <!-- The tab bar already shows this label visually; the heading exists for screen readers and
       document structure, so it is visually hidden to avoid repeating the word on screen. -->
  <h1 class="sr-only">Monitoring</h1>

  <!--
    Sectioned rather than one flat list: the next things to land here (queue depths, NYC call
    health, notification delivery) are different kinds of measurement, and each gets its own
    section with its own grid.
  -->
  <section aria-labelledby="background-jobs-heading">
    <h2 id="background-jobs-heading" class="text-sm font-semibold text-slate-700 mb-3">
      Background jobs
    </h2>

    <div class="grid gap-4 sm:grid-cols-2 xl:grid-cols-3" aria-live="polite">
      @if (loading()) {
        <p class="text-sm text-muted-color">Loading…</p>
      } @else if (jobCards().length === 0) {
        <p class="text-sm text-muted-color">Status could not be loaded.</p>
      } @else {
        @for (card of jobCards(); track card.key) {
          <article class="rounded-lg border border-slate-200 p-4">
            <div class="flex items-start justify-between gap-3">
              <h3 class="text-sm font-medium text-slate-700">{{ card.title }}</h3>

              <!-- The dot repeats what the text says; on its own colour would carry the whole
                   status, which fails for anyone who cannot distinguish red from green. -->
              @switch (card.state) {
                @case ('ok') {
                  <span class="flex items-center gap-1.5 text-xs font-semibold text-green-700">
                    <span class="size-2 rounded-full bg-green-600" aria-hidden="true"></span>
                    Up to date
                  </span>
                }
                @case ('stale') {
                  <span class="flex items-center gap-1.5 text-xs font-semibold text-red-600">
                    <span class="size-2 rounded-full bg-red-600" aria-hidden="true"></span>
                    Stale
                  </span>
                }
                @default {
                  <span class="flex items-center gap-1.5 text-xs font-semibold text-muted-color">
                    <span class="size-2 rounded-full bg-slate-400" aria-hidden="true"></span>
                    Unknown
                  </span>
                }
              }
            </div>

            <p
              class="mt-3 text-2xl font-semibold"
              [class.text-red-600]="card.state === 'stale'"
              [class.text-slate-800]="card.state !== 'stale'"
            >
              {{ card.headline }}
            </p>

            @if (card.lastCompletedAt) {
              <p class="text-sm text-muted-color">
                Last completed {{ card.lastCompletedAt | date: dateTimeFormat }}
              </p>
            } @else {
              <p class="text-sm text-muted-color">No completed run recorded yet</p>
            }

            <p class="mt-3 text-xs text-muted-color">{{ card.cadence }}</p>
            <p class="text-xs text-muted-color">{{ card.threshold }}</p>
          </article>
        }
      }
    </div>
  </section>
</div>
